import { jsx } from "react/jsx-runtime";
import classnames from "../../utils/classnames.js";
import Typography from "../Typography/Typography.js";
import './FinanceProgram.css';/* empty css                    */
const ProgramTitle = ({ title, className }) => {
  return /* @__PURE__ */ jsx("div", { className: classnames("perxis-auto-finance-program-title", className), children: /* @__PURE__ */ jsx(
    Typography.Title,
    {
      headingLevel: 4,
      level: "h4",
      color: "darkest",
      className: classnames("perxis-auto-finance-program-title__heading"),
      children: title
    }
  ) });
};
export {
  ProgramTitle as default
};
//# sourceMappingURL=FinanceProgramTitle.js.map
